import { render, staticRenderFns } from "./project-custom-field-delete.component.vue?vue&type=template&id=7608c32b&"
import script from "./project-custom-field-delete.component.vue?vue&type=script&lang=ts&"
export * from "./project-custom-field-delete.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports